import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBaseConfigFormDialog, LazyBaseFormDialog, LazyBaseLanguageSwitcher, LazyBaseMenuButton, LazyBaseMobileSidebarBackdrop, LazyBaseMobileSidebarCloseButton, LazyBaseMobileSidebarToggle, LazyBaseClientStatusClientConfigStatusIcons, LazyBaseDialogsConfigChangesDialog, LazyBaseDialogsConfigEditorLockedDialog, LazyBaseDialogsConfirmPermissionDialog, LazyBaseDialogsDelegateClientSelector, LazyBaseDialogsMissingFieldsDialog, LazyBaseDialogsPendingDeletionsDialog, LazyBaseDialogsSaveFormDialog, LazyBaseDialogsUnsavedChangesDialog, LazyBaseFormsActionScheduler, LazyBaseFormsAssignProfile, LazyBaseFormsConfigFormFields, LazyBaseFormsConfigFormHeadlines, LazyBaseFormsConfigFormTabs, LazyBaseFormsPasswordStrengthMeter, LazyBaseFormsPermissionField, LazyModuleBackupScheduler, LazyModuleClientDataView, LazyModuleClientForm, LazyModuleClientGroupDataView, LazyModuleConfigForm, LazyModuleConfigProfile, LazyModuleGroupForm, LazyModuleMessageQueue, LazyModuleProfileDataView, LazyModuleProfileForm, LazyModuleRolesDataView, LazyModuleRolesForm, LazyModuleScheduledActionsDataView, LazyModuleSidebarClients, LazyModuleSidebarConfig, LazyModuleSidebarConfigProfile, LazyModuleSidebarRoles, LazyModuleSidebarSettings, LazyModuleSidebarTenants, LazyModuleSidebarUserGroups, LazyModuleSidebarUsers, LazyModuleTenantForm, LazyModuleTenantDataView, LazyModuleUserDataView, LazyModuleUserGroupDataView, LazyModuleUserGroupForm, LazyModuleUserForm } from '#components'
const lazyGlobalComponents = [
  ["BaseConfigFormDialog", LazyBaseConfigFormDialog],
["BaseFormDialog", LazyBaseFormDialog],
["BaseLanguageSwitcher", LazyBaseLanguageSwitcher],
["BaseMenuButton", LazyBaseMenuButton],
["BaseMobileSidebarBackdrop", LazyBaseMobileSidebarBackdrop],
["BaseMobileSidebarCloseButton", LazyBaseMobileSidebarCloseButton],
["BaseMobileSidebarToggle", LazyBaseMobileSidebarToggle],
["BaseClientStatusClientConfigStatusIcons", LazyBaseClientStatusClientConfigStatusIcons],
["BaseDialogsConfigChangesDialog", LazyBaseDialogsConfigChangesDialog],
["BaseDialogsConfigEditorLockedDialog", LazyBaseDialogsConfigEditorLockedDialog],
["BaseDialogsConfirmPermissionDialog", LazyBaseDialogsConfirmPermissionDialog],
["BaseDialogsDelegateClientSelector", LazyBaseDialogsDelegateClientSelector],
["BaseDialogsMissingFieldsDialog", LazyBaseDialogsMissingFieldsDialog],
["BaseDialogsPendingDeletionsDialog", LazyBaseDialogsPendingDeletionsDialog],
["BaseDialogsSaveFormDialog", LazyBaseDialogsSaveFormDialog],
["BaseDialogsUnsavedChangesDialog", LazyBaseDialogsUnsavedChangesDialog],
["BaseFormsActionScheduler", LazyBaseFormsActionScheduler],
["BaseFormsAssignProfile", LazyBaseFormsAssignProfile],
["BaseFormsConfigFormFields", LazyBaseFormsConfigFormFields],
["BaseFormsConfigFormHeadlines", LazyBaseFormsConfigFormHeadlines],
["BaseFormsConfigFormTabs", LazyBaseFormsConfigFormTabs],
["BaseFormsPasswordStrengthMeter", LazyBaseFormsPasswordStrengthMeter],
["BaseFormsPermissionField", LazyBaseFormsPermissionField],
["ModuleBackupScheduler", LazyModuleBackupScheduler],
["ModuleClientDataView", LazyModuleClientDataView],
["ModuleClientForm", LazyModuleClientForm],
["ModuleClientGroupDataView", LazyModuleClientGroupDataView],
["ModuleConfigForm", LazyModuleConfigForm],
["ModuleConfigProfile", LazyModuleConfigProfile],
["ModuleGroupForm", LazyModuleGroupForm],
["ModuleMessageQueue", LazyModuleMessageQueue],
["ModuleProfileDataView", LazyModuleProfileDataView],
["ModuleProfileForm", LazyModuleProfileForm],
["ModuleRolesDataView", LazyModuleRolesDataView],
["ModuleRolesForm", LazyModuleRolesForm],
["ModuleScheduledActionsDataView", LazyModuleScheduledActionsDataView],
["ModuleSidebarClients", LazyModuleSidebarClients],
["ModuleSidebarConfig", LazyModuleSidebarConfig],
["ModuleSidebarConfigProfile", LazyModuleSidebarConfigProfile],
["ModuleSidebarRoles", LazyModuleSidebarRoles],
["ModuleSidebarSettings", LazyModuleSidebarSettings],
["ModuleSidebarTenants", LazyModuleSidebarTenants],
["ModuleSidebarUserGroups", LazyModuleSidebarUserGroups],
["ModuleSidebarUsers", LazyModuleSidebarUsers],
["ModuleTenantForm", LazyModuleTenantForm],
["ModuleTenantDataView", LazyModuleTenantDataView],
["ModuleUserDataView", LazyModuleUserDataView],
["ModuleUserGroupDataView", LazyModuleUserGroupDataView],
["ModuleUserGroupForm", LazyModuleUserGroupForm],
["ModuleUserForm", LazyModuleUserForm],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
